// Single source of truth for the structural caps + numeric bounds that
// gate accepted submission payloads. Imported by both functions/ (server
// validation) and src/ (canvas dims, authoring UI caps), so the
// validator and the editor can never drift apart.
//
// Bounds are deliberately loose — they're a sanity backstop, not a
// duplicate of the slider ranges. As long as the LightingEditor /
// CreativePanel sliders produce values inside these, the server stays
// out of the way.

export const MAX_STROKES_BYTES = 2 * 1024 * 1024;
export const MAX_STROKES_COUNT = 2000;
export const MAX_PEN_POINTS_PER_STROKE = 10000;
export const MAX_PALETTE_LENGTH = 32;

export const CANVAS_WIDTH = 792;
export const CANVAS_HEIGHT = 1018;

// Cap for the optional creative-mode override bag carried on a
// syndicated submission. LightingEditor disables "Add light" at this
// count so a real user never bumps it; the server cap defends against
// a hand-crafted payload.
export const MAX_EGG_LIGHTS = 8;

export const TRANSFORM_BOUNDS = {
  tx: [-CANVAS_WIDTH * 4, CANVAS_WIDTH * 4],
  ty: [-CANVAS_HEIGHT * 4, CANVAS_HEIGHT * 4],
  scale: [0.01, 100],
  scaleX: [0.01, 100],
  rotation: [-3600, 3600],
};

export const TINT_RANGE = [0, 100];

export const LIGHT_BOUNDS = {
  intensity: [0, 1],
  shadow: [0, 1],
  size: [0, 1],
  direction: [-1, 1],
};
